var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxtColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.36,
    height: 22.76,
    viewBox: "0 0 17.36 22.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TXT",
    transform: "translate(-1 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M18.35,22.08a.681.681,0,0,1-.67.69H1.67A.681.681,0,0,1,1,22.08V.7A.681.681,0,0,1,1.67.01H13.48c.87.93,4.51,4.47,4.88,4.94V22.07Z",
    fill: "#e0f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M18.35,15.86H1v6.2a.681.681,0,0,0,.67.69H17.69a.681.681,0,0,0,.67-.69V15.87Z",
    fill: "#44546c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M13.51.02V4.31a.628.628,0,0,0,.62.61h4.18Z",
    fill: "#99badb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M7.64,18.47H6.61v2.84H6.04V18.47H5.02v-.46H7.64v.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M9.21,19.2l.69-1.19h.66l-1,1.64,1.02,1.66H9.91L9.2,20.1l-.71,1.21H7.82l1.02-1.66-1-1.64H8.5l.69,1.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M13.39,18.47H12.36v2.84h-.57V18.47H10.77v-.46h2.62Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713",
    "data-name": "Rectangle 1713",
    width: 10,
    height: 1,
    rx: 0.48,
    transform: "translate(3.35 6.31)",
    fill: "#44546c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1714",
    "data-name": "Rectangle 1714",
    width: 8.18,
    height: 1,
    rx: 0.48,
    transform: "translate(3.35 9.31)",
    fill: "#44546c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715",
    "data-name": "Rectangle 1715",
    width: 5.45,
    height: 1,
    rx: 0.48,
    transform: "translate(3.35 12.31)",
    fill: "#44546c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    cx: 0.45,
    cy: 0.5,
    rx: 0.45,
    ry: 0.5,
    transform: "translate(9.72 12.31)",
    fill: "#44546c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtColorIcon);
export default __webpack_public_path__ + "static/media/txt-color-icon.8e76c758f5a92de08af623c249044678.svg";
export { ForwardRef as ReactComponent };